import {Asset, Folder} from '../Assets.types';
import getAllAssetUrls from '../../../components/CLAssetDisplay/utils/getAllAssetUrls';
import normalizeUrl from '../../../components/CLAssetDisplay/utils/normalizeUrl';

/**
 * Finds an asset in the asset tree by URL
 * Matches against all URLs associated with an asset (original, derivatives, etc.)
 * @param tree - The asset folder tree to search
 * @param url - The URL to find
 * @returns The asset if found, null otherwise
 */
export default function findAssetByUrl(tree: Folder | null, url: string): Asset | null {
  if (!tree || !url) {
    return null;
  }

  const normalizedSearchUrl = normalizeUrl(url);

  // Check assets in current folder
  if (tree.assets) {
    for (const asset of tree.assets) {
      const assetUrls = getAllAssetUrls(asset);
      const normalizedAssetUrls = assetUrls.map(normalizeUrl);

      if (normalizedAssetUrls.includes(normalizedSearchUrl)) {
        return asset;
      }
    }
  }

  // Recursively search subfolders
  if (tree.folders) {
    for (const subfolder of tree.folders) {
      const found = findAssetByUrl(subfolder, url);

      if (found) {
        return found;
      }
    }
  }

  return null;
}

